import { useState } from 'react';
import { useLoaderData } from 'react-router-dom';

import { inmunetApi } from '../../api';

import { LightButton, PrimaryButton } from '../../components';

import styles from './AppLinking.module.css';

export async function loader({ params }) {
    return params.token;
}

export const AppLinking = () => {

    const token = useLoaderData();

    const [state, setState] = useState({ link: null, requested: false, loading: null, status: null, msg: '', errorMsg: '' });

    let { link, requested, loading, status, msg } = state;

    const handleEnlazar = () => {

        setState({ link: true, requested: true, loading: true, status: null, msg: '', errorMsg: '' });

        async function fetchData() {

            localStorage.setItem('token', token);

            try {

                let res = await inmunetApi.post('/usuarioPaciente/enlazar-app');

                localStorage.removeItem('token');

                setState({ link: true, requested: true, loading: false, status: res.data.status, msg: res.data.msg, errorMsg: '' });

            } catch (error) {

                localStorage.removeItem('token');

                if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.msg !== 'undefined') {
                    
                    setState({ link: true, requested: true, loading: false, status: error.response.data.status, errorMsg: error.response.data.msg });
                    
                } else {
                    
                    setState({ link: true, requested: true, loading: false, status: error.response.data.status, errorMsg: 'Error al procesar la petición, intenta nuevamente.' });
    
                }

            }

        }

        fetchData();

    }

    const handleNoEnlazar = () => {

        setState({ link: false, requested: true, loading: true, status: null, msg: '', errorMsg: '' });

        async function fetchData() {

            localStorage.setItem('token', token);

            try {

                let res = await inmunetApi.post('/usuarioPaciente/desenlazar-app');

                localStorage.removeItem('token');

                setState({ link: false, requested: true, loading: false, status: res.data.status, msg: res.data.msg, errorMsg: '' });

            } catch (error) {

                localStorage.removeItem('token');

                if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.msg !== 'undefined') {
                    
                    setState({ link: false, requested: true, loading: false, status: error.response.data.status, errorMsg: error.response.data.msg });
                    
                } else {
                    
                    setState({ link: false, requested: true, loading: false, status: error.response.data.status, errorMsg: 'Error al procesar la petición, intenta nuevamente.' });
    
                }

            }

        }

        fetchData();

    }

    return (
        <>
            <div className={styles.logoContainer}>
                <div className={styles.logo}></div>
            </div>
            {!requested &&
            <div className={styles.description}>Tu médico ha solicitado enlazar tu aplicación móvil. Al aceptar, podrás viasualizar información y dar seguimiento a tu atención a través de la aplicación móvil Inmunet.</div>
            }
            {!requested &&
            <div className={styles.description + ' mt-3 mb-3'}>¿Deseas enlazar tu cuenta?</div>
            }
            {!requested &&
            <div className='row mb-3'>
                <div className="col">
                    <PrimaryButton
                        block={true}
                        icon="Check"
                        marginTop={false}
                        onClick={handleEnlazar}
                        text="Enlazar"
                        type="submit"
                    />
                </div>
                <div className="col">
                    <LightButton
                        block={true}
                        icon="X"
                        marginRight={true}
                        marginTop={false}
                        onClick={handleNoEnlazar}
                        text="No enlazar"
                        type="button"
                    />
                </div>
            </div>
            }
            {requested
                ? loading 
                    ? (
                    <div className='alert alert-info text-center'>procesando...</div>
                    )
                    : (
                    !status
                        ? (
                            <>
                                <div className='alert alert-danger text-center'>Error al procesar enlace! Intenta nuevamente, si el problema persiste contacta con el equipo de soporte.</div>
                            </>
                        )
                        : (
                            <>
                                <div className="alert alert-success text-center">
                                    {msg ? (
                                        msg
                                    ) : (
                                        link
                                        ? <>
                                            ¡Bienvenido a Inmunet, tu aplicación ha sido enlazada.{" "}
                                            Inicia sesión en la aplicación. Si no recuerdas tus credenciales de acceso usa la recuperación de contraseña.
                                            </>
                                        : <>
                                            ¡Enlace rechazado, tu aplicación permanecera desenlazada de tu médico.{" "}
                                            </>
                                    )}
                                </div>
                            </>
                        )
                    )
                : <></>
            }
        </>
    )
}
